import { isUserRole } from "../../helpers/users";
import { User } from "../../models/user";
import { UserRole } from "../../types/enums";

export const transformUser = (user: User) => {
  user.fullName = [user.givenName, user.familyName].filter((name) => name).join(" ");
  user.initials = user.fullName
    .split(" ")
    .map((name) => name[0])
    .join("");
  user.role = isUserRole(user.role) ? user.role : UserRole.USER;
  return user;
};
